import "./header.css";
import React, { useState, useEffect } from "react";
import { Form, Link } from "react-router-dom";
import logo from "../resources/revivalGrey-1-block.png";
import Dashboard from "../resources/icons/dashboard.png";
import LiveStreaming from "../resources/icons/live (1).png";
import Events from "../resources/icons/calendar (1).png";
import Forms from "../resources/icons/check (2).png";
import Groups from "../resources/icons/group (1).png";
import Members from "../resources/icons/user (1).png";
import Donations from "../resources/icons/heart (1).png";
import Prayer from "../resources/icons/pray (1).png";
import Serving from "../resources/icons/volunteer (1).png";
import Testimonies from "../resources/icons/testimonial (1).png";
import { signOut } from "firebase/auth";
import { auth } from "../firebase/firebaseAuth";
import { useNavigate } from 'react-router-dom';

const Menu = () => {
    const navigate = useNavigate();
    
    const handleLogout = () => {
        signOut(auth).then(() => {
          navigate('/'); 
        });
    };

    return (
    <div id="menu">
        <div className="menu-top">
            <img src={logo} alt="company-logo" width="50%"/>
            <h1 className="rcc-name">Revival Church Montana</h1>
            <p className="rcc-desc">Status: Campus Admin</p>
        </div>
        <div className="menu-items">
            <ul className="social-media-menu">
                {/* <li><img src={Dashboard} width="25px" style={{marginRight: '10px'}}/>Dashboard</li> */}
                <li><Link to="/live-streaming"><img src={LiveStreaming} width="25px" style={{marginRight: '10px'}}/>Live Streaming</Link></li>
                <li><Link to="/events-calendar"><img src={Events} width="25px" style={{marginRight: '10px'}}/>Events Calendar</Link></li>
                <li><Link to="/forms-builder"><img src={Forms} width="25px" style={{marginRight: '10px'}}/>Forms</Link></li>
                <li><Link to="/groups"><img src={Groups} width="25px" style={{marginRight: '10px'}}/>Groups</Link></li>
                <li><Link to="/members"><img src={Members} width="25px" style={{marginRight: '10px'}}/>Members</Link></li>
                <li><Link to="/donations"><img src={Donations} width="25px" style={{marginRight: '10px'}}/>Donations</Link></li>
                <li><Link to="/prayer-wall"><img src={Prayer} width="25px" style={{marginRight: '10px'}}/>Prayer Wall</Link></li>
                <li><Link to="/serving"><img src={Serving} width="25px" style={{marginRight: '10px'}}/>Serving</Link></li>
                <li><Link to="/testimonies"><img src={Testimonies} width="25px" style={{marginRight: '10px'}}/>Testimonies</Link></li>
            </ul>
        </div>
        <div className="menu-bottom">
            <p><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-box-arrow-in-right" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0z"/>
                <path fill-rule="evenodd" d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
            </svg> <a style={{"margin-left": "10px"}} onClick={handleLogout}>Log Out</a></p>
        </div>
    </div>
  );
}

export default Menu;
